import api from '@/libs/axios'

export default {
  getInspects: () => api.get('/system/inspect'),
  getInspectById: id => api.get(`/system/inspect/${id}`),
  editInspect: form => api.patch(`/system/inspect/${form.id}`, form),
  createInspect: form => api.post('/system/inspect', form),
  deleteInspect: array => api.delete('/system/inspect', array),
}
